import { createFileRoute, redirect } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { CreateDistributorScreen } from '../features/distributors/CreateDistributorScreen'
import { redirectIfNotPlatformAdmin } from '../lib/platformAdminGuard'

/** `/distributors/new` — форма создания тенанта (PA-4, D16 §2.7). Доступно
 *  только PLATFORM_ADMIN с permission `platform.distributors.create` —
 *  permission-check внутри экрана; route-guard здесь только отрезает не-PA. */
export const Route = createFileRoute('/distributors/new')({
  beforeLoad: () => {
    redirectIfNotPlatformAdmin(redirect)
  },
  component: DistributorsNewRoute,
})

function DistributorsNewRoute() {
  return (
    <RequireAuth>
      <CreateDistributorScreen />
    </RequireAuth>
  )
}
